import intlTelInput from 'intl-tel-input';

require('./style.scss');

var buildPhoneCode = function(phoneCountryField) {
  const input = $(this);
  var phoneCountryVal = phoneCountryField.val();
  var initValueCountry = undefined;
  
  if (phoneCountryVal === ''){
    initValueCountry = "fr";
  } else {
    initValueCountry = phoneCountryVal;
  }
  var iti = intlTelInput(input.get(0), {
    initialCountry:  initValueCountry,
    separateDialCode: true
    // any initialisation options go here
  });
  phoneCountryField.val(iti.getSelectedCountryData().iso2);

   input.on('countrychange', function(e){
     console.log(e);
     phoneCountryField.val(iti.getSelectedCountryData().iso2);
   });
};

export default buildPhoneCode;
